import React from 'react'
import Button from '@mui/material/Button'

import GoogleIcon from '../icon/GoogleIcon'

const DEFAULT_ACTION_BUTTON_COLOR = '#597FA9'
const DEFAULT_OUTLINED_TEXT_COLOR = '#7B7780'

export default function ActionButton({
  text,
  icon,
  iconSize = 16,
  filled = false,
  variant = 'contained',
  color = DEFAULT_ACTION_BUTTON_COLOR,
  hoverColor,
  textColor,
  type = 'button',
  onClick,
  disabled = false,
  fullWidth = false,
  sx = {},
  ...buttonProps
}) {
  const isContained = variant === 'contained'
  const resolvedTextColor = textColor || (isContained ? '#FFFFFF' : DEFAULT_OUTLINED_TEXT_COLOR)
  const resolvedHoverColor = hoverColor || color

  return (
    <Button
      type={type}
      variant={variant}
      fullWidth={fullWidth}
      disabled={disabled}
      onClick={onClick}
      disableElevation
      startIcon={
        icon ? (
          <GoogleIcon name={icon} size={iconSize} filled={filled} color="inherit" />
        ) : undefined
      }
      sx={{
        minHeight: 35,
        borderRadius: 0.75,
        px: 2,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        textTransform: 'uppercase',
        boxShadow: 'none',
        ...(isContained
          ? {
              backgroundColor: color,
              border: `1px solid ${color}`,
              color: resolvedTextColor,
              '&:hover': {
                backgroundColor: resolvedHoverColor,
                borderColor: resolvedHoverColor,
                boxShadow: 'none'
              }
            }
          : {
              backgroundColor: '#FFFFFF',
              borderColor: color,
              color: resolvedTextColor,
              '&:hover': {
                backgroundColor: '#FFFFFF',
                borderColor: resolvedHoverColor,
                color: resolvedTextColor
              }
            }),
        '&.Mui-disabled': {
          boxShadow: 'none'
        },
        ...sx
      }}
      {...buttonProps}
    >
      {text}
    </Button>
  )
}
